import React from "react";

/**
 * CanvasPreview - Renders the actual visual preview of the content
 * with proper HTML structure (headings, images, text styles).
 * Future-ready for social/blog preview modes.
 * 
 * @param {string} content - The raw content with markup
 * @param {Object} images - Images map { filename: base64data }
 * @param {string} mode - (Optional) Preview mode like "blog", "social"
 */
const CanvasPreview = ({ content, images = {}, mode = "default" }) => {
  // Render flow - convert custom markup to real HTML elements
  const renderProcessedContent = () => {
    let processed = content;

    // Replace images
    Object.entries(images).forEach(([filename, base64]) => {
      const imgTag = `<img src="${base64}" alt="${filename}" class="max-w-full h-auto rounded my-4" />`;
      processed = processed.replaceAll(`[Image: ${filename}]`, imgTag);
    });

    // Headings: ## H2, ### H3
    processed = processed.replace(/^### (.*$)/gm, "<h3 class='text-lg font-semibold'>$1</h3>");
    processed = processed.replace(/^## (.*$)/gm, "<h2 class='text-xl font-bold'>$1</h2>");

    // Font Size Tags
    processed = processed.replace(
      /\[FontSize:(\d+)\](.*?)\[\/FontSize\]/g,
      '<span style="font-size: $1px">$2</span>'
    );

    // Bold / Italic / Code
    processed = processed.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
    processed = processed.replace(/_(.*?)_/g, "<em>$1</em>");
    processed = processed.replace(/`(.*?)`/g, "<code class='bg-gray-100 px-1 rounded'>$1</code>");

    // Line breaks
    processed = processed.replace(/\n/g, "<br>");

    return processed;
  };

  return (
    <div className={`prose max-w-full ${mode === "blog" ? "text-gray-800" : ""}`}> 
      <div dangerouslySetInnerHTML={{ __html: renderProcessedContent() }} />
    </div>
  );
};

export default CanvasPreview;

